import { Injectable } from '@angular/core';
import Mark from 'mark.js';

/** Servicio para resaltar visualmente textos en la aplicación */
import * as ɵngcc0 from '@angular/core';
class HighlightTextService {
    /** @ignore */
    constructor() {
        this._instance = null;
    }
    /**
     * Método para crear la instancia donde se resaltará el texto que se indique
     *
     * @param instance Instancia en la cual se remarcará el texto que se indique con el método 'mark(text: string)'
     */
    createInstance(instance) {
        this._instance = new Mark(instance);
    }
    /**
     * Método para resaltar el texto indicado en el campo 'text'
     *
     * @param text Texto a remarcar
     */
    mark(text) {
        this._instance.mark(text);
    }
    /**
     * Método para quitar todo el texto remarcado
     */
    unmark() {
        this._instance.unmark();
    }
}
HighlightTextService.ɵfac = function HighlightTextService_Factory(t) { return new (t || HighlightTextService)(); };
HighlightTextService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HighlightTextService, factory: HighlightTextService.ɵfac });
/** @nocollapse */
HighlightTextService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HighlightTextService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Esta clase está relacionada con el objeto 'PageInfo', la cual incluye las diferentes opciones configurables tales como el tamaño
 * de la página y la primera y última página de la DataGrid
 *
 */
class PageInfo {
    /**@ignore */
    constructor(pageNumber, pageSize) {
        this.pageNumber = pageNumber;
        this.pageSize = pageSize;
    }
    /**
     * Esta función devuelve toda la información sobre los diferentes objetos recogido en un objeto de tipo PageInfo
     *
     * @return
     */
    static AllItems() {
        let pageInfo = new PageInfo(1, 0);
        return pageInfo;
    }
    /**
     * Esta función devuelve toda la información sobre la primera página de la DataGrid
     *
     * @return
     */
    static FirstPage() {
        let pageInfo = new PageInfo(1, PageInfo.DefaultPageSize);
        return pageInfo;
    }
    /**
     * Esta función devuelve el identificador del primer item que se encuentre en la página 'pageInfo' que se le pasa como parámetro
     *
     * @param pageInfo PageInfo a analizar para obtener el identificador del primer item
     * @return
     */
    static FirstItem(pageInfo) {
        if (pageInfo.pageNumber === 0 || pageInfo.total === 0) {
            return 0;
        }
        else {
            return pageInfo.pageSize * (pageInfo.pageNumber - 1);
        }
    }
    /**
     * Esta función devuelve el identificador del último item que se encuentre en la página 'pageInfo' que se le pasa como parámetro
     *
     * @param pageInfo PageInfo a analizar para obtener el identificador del último item
     * @return
     */
    static LastItem(pageInfo) {
        if (pageInfo.pageNumber === 0) {
            return 0;
        }
        else if (pageInfo.pageNumber * pageInfo.pageSize > pageInfo.total) {
            return pageInfo.total;
        }
        else {
            return pageInfo.pageSize * pageInfo.pageNumber;
        }
    }
    /**
     * Esta función obtiene el PageInfo que viene a continuación del PageInfo 'pageInfo' que se le pasa como parámetro
     *
     * @param pageInfo PageInfo a analizar para obtener el próximo PageInfo
     * @return
     */
    static NextPage(pageInfo) {
        return new PageInfo(pageInfo.pageNumber + 1, pageInfo.pageSize);
    }
    /**
     * Esta función devuelve true si el PageInfo 'pageInfo' pasado como parámetro es la primera página creada
     *
     * @param pageInfo PageInfo a analizar para saber si es la primera página creada
     * @return
     */
    static IsFirstPage(pageInfo) {
        return pageInfo.pageNumber === 1;
    }
    /**
     * Esta función devuelve true si el PageInfo 'pageInfo' pasado como parámetro es la última página creada
     *
     * @param pageInfo PageInfo a analizar para saber si es la última página creada
     * @return
     */
    static IsLastPage(pageInfo) {
        return (pageInfo.total === 0 ||
            pageInfo.pageNumber === Math.ceil(pageInfo.total / pageInfo.pageSize));
    }
    /**
     * Pasa a la siguiente página partiendo de la página actual donde se encuentra la DataGrid
     *
     * @return
     */
    Skip() {
        return this.pageNumber * this.pageSize - this.pageSize;
    }
}
/** Tamaño de la PageInfo. Por defecto es 50 lineas por página */
PageInfo.DefaultPageSize = 50;

/** Contiene los datos necesarios para obtener información de una entidad */
class QueryRequest {
}
/**
 * Define que propiedad y con que orden se debe ordenar.
 */
class SortProperty {
}
/**
 * Tipo de orden
 */
var SortType;
(function (SortType) {
    /** orden ascendente */
    SortType[SortType["ASC"] = 0] = "ASC";
    /** orden descendente */
    SortType[SortType["DESC"] = 1] = "DESC";
})(SortType || (SortType = {}));

/** Respuesta a una consulta (generalmente mediante QueryRequest) */
class QueryResponse {
}

/**
 * Generated bundle index. Do not edit.
 */

export { HighlightTextService, PageInfo, QueryRequest, QueryResponse, SortProperty, SortType };

